import React, { useEffect, useState } from "react";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Approach", href: "#approach" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-brand"
          className="font-mono-accent text-sm md:text-base tracking-[0.15em] text-white hover:text-[#00FFD1] transition-colors duration-300"
        >
          WOLF&nbsp;LAND
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="nav-underline font-mono-accent text-[13px] tracking-[0.12em] uppercase text-[#A3A3A3] hover:text-[#00FFD1] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta-button"
          className="font-mono-accent text-[12px] tracking-[0.12em] uppercase px-5 py-2.5 border border-white/20 text-white hover:text-[#00FFD1] hover:border-[#00FFD1] transition-colors duration-300"
        >
          Enquire
        </a>
      </div>
    </header>
  );
};
